import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { DropDown_DiseaseView } from '../../_entity/disease-view/ui-components.js';
import { DropDown_DiseaseProfile } from '../../_entity/disease-profile/ui-components.js';
export const DPDropDowns = {
    DiseaseProfile: DropDown_DiseaseProfile.selectable,
    DiseaseValue: () => _jsx(_Fragment, {}),
    MultiVar: () => _jsx(_Fragment, {}),
    DiseaseView: DropDown_DiseaseView.selectable,
};
//# sourceMappingURL=app-dropdowns.js.map